import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
import './scss/main.scss';
import './js/global.js';
import './js/test.js';
import './js/slick.js';
